import { render, staticRenderFns } from "./AgencyRender.vue?vue&type=template&id=3f47e58e&scoped=true&"
import script from "./AgencyRender.vue?vue&type=script&lang=js&"
export * from "./AgencyRender.vue?vue&type=script&lang=js&"
import style0 from "./AgencyRender.vue?vue&type=style&index=0&id=3f47e58e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f47e58e",
  null
  
)

export default component.exports
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QScrollArea,QItemLabel});
